import { takeLatest, put, call } from 'redux-saga/effects';

import * as services from './services';
import Creators, { ExcelTypes as constants } from './reducer';

const actions = {
  saveFileActions: {
    request: Creators.saveFileRequest,
    success: Creators.saveFileSuccess,
    errors: Creators.saveFileFailure,
  }
};

const eventsOptions = {
  [constants.SAVE_FILE_REQUEST]: {
    api: services.saveTable,
    actions: actions.saveFileActions,
  },
};

function* apiGenerator(action) {
  const provider = eventsOptions[action.type];

  try {
    const params = action.payload;
    const response = yield call(provider.api, params);

    if (response.ok && response.data) {
      yield put(provider.actions.success(response.data));
    } else {
      yield put(provider.actions.errors({ errors: response.data?.message?.detail || "some error"  }));
    }
  } catch (errors) {
    yield put(provider.actions.errors({ errors }));
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.SAVE_FILE_REQUEST, apiGenerator);
}
